import React from 'react';
import {formatTime} from "@helpers/formatTime";

const EpisodeLengthMobile = ({currentTime}) => {
    return (
        <div className="player-app__time-mobile">
            {formatTime(currentTime)}
        </div>
    );
};

export default EpisodeLengthMobile;
